import { useEffect, useState } from "react";
import API from "../../../../services/api";

const useEarnings = () => {
  const [summary, setSummary] = useState({
    totalOrders: 0,
    totalEarnings: 0,
    todayEarnings: 0,
    weeklyEarnings: 0,
    monthlyEarnings: 0,
    pendingSettlement: 0,
  });

  const [transactions, setTransactions] = useState([]);

  const [analytics, setAnalytics] = useState([]);

  const [pendingSettlements, setPendingSettlements] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  // ======================================
  // Summary
  // ======================================

  const fetchSummary = async () => {
    try {
      const { data } = await API.get("/earnings/summary");

      setSummary(data);
    } catch (err) {
      console.log(err);

      setError(
        err.response?.data?.message ||
          "Unable to load earnings summary."
      );
    }
  };

  // ======================================
  // Transactions
  // ======================================

  const fetchTransactions = async () => {
    try {
      const { data } = await API.get("/earnings/all");

      setTransactions(data.earnings || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ======================================
  // Analytics
  // ======================================

  const fetchAnalytics = async () => {
    try {
      const { data } = await API.get(
        "/earnings/analytics"
      );

      setAnalytics(data.analytics || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ======================================
  // Pending Settlement
  // ======================================

  const fetchPendingSettlements =
    async () => {
      try {
        const { data } = await API.get(
          "/earnings/pending"
        );

        setPendingSettlements(
          data.pending || []
        );
      } catch (err) {
        console.log(err);
      }
    };

  // ======================================
  // Refresh
  // ======================================

  const refresh = async () => {
    try {
      setLoading(true);

      await Promise.all([
        fetchSummary(),
        fetchTransactions(),
        fetchAnalytics(),
        fetchPendingSettlements(),
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return {
    summary,

    transactions,

    analytics,

    pendingSettlements,

    loading,

    error,

    refresh,
  };
};

export default useEarnings;